import script from "./PaymentDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentDetails.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentDetails.vue?vue&type=style&index=0&id=922e2aac&lang=sass"

const __exports__ = script;

export default __exports__